export const DESKTOP_ASSET_BODY = 'desktopAssetBody';
